module.exports = __webpack_public_path__ + "static/media/rouge.77770272.png";